import { observable } from 'mobx';
import type { ProjectResponseArgs } from './project2';
import Project, { convertProjectResponseToArgs } from './project2';

export type ProjectShareMappingResponseArgs = {
  id: number;
  project_id: number;
  project?: ProjectResponseArgs;
  project_share_id: number;
  weight: number;
};

export type ProjectShareMappingArgs = {
  id: number;
  projectId: number;
  project?: Project;
  projectShareId: number;
  weight: number;
};

export const convertProjectShareMappingResponseToArgs = (response: ProjectShareMappingResponseArgs) => {
  const args: ProjectShareMappingArgs = {
    id: response.id,
    projectId: response.project_id,
    project: response.project ? new Project(convertProjectResponseToArgs(response.project)) : undefined,
    projectShareId: response.project_share_id,
    weight: response.weight
  };
  return args;
};

export default class ProjectShareMapping {
  @observable id: number;
  @observable projectId: number;
  @observable project?: Project;
  @observable projectShareId: number;
  @observable weight: number;

  constructor(args: ProjectShareMappingArgs) {
    this.id = args.id;
    this.projectId = args.projectId;
    this.project = args.project;
    this.projectShareId = args.projectShareId;
    this.weight = args.weight;
  }
}
